import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { IconBase } from '../internal/IconBase.js';
/**
 * `Palette` — artist palette with dots.
 * Aria label:    Palette
 * Family:        misc
 * Related:       code, code-2, code-xml, terminal, git-branch, git-commit
 * Canonical use: palette glyph in general UI surfaces.
 * Audited 2026-09-20 — no-op (5/5 criteria pass). Palette.
 *
 */
export const Palette = forwardRef(function Palette(props, ref) {
    return (_jsxs(IconBase, { ref: ref, ...props, children: [_jsx("path", { d: "M12 3 a9 9 0 1 0 0 18 c2 0 3 -2 3 -3 a2 2 0 0 1 2 -2 h2 a4 4 0 0 0 4 -4 a9 9 0 0 0 -11 -9 z" }), _jsx("circle", { cx: "7", cy: "11", r: "0.5" }), _jsx("circle", { cx: "9", cy: "7", r: "0.5" }), _jsx("circle", { cx: "13", cy: "7", r: "0.5" }), _jsx("circle", { cx: "17", cy: "11", r: "0.5" })] }));
});
//# sourceMappingURL=palette.js.map